import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Award, Globe, Package, Truck, Bot, ArrowUpRightSquare } from "lucide-react";

export default function About() {
  return (
    <div className="space-y-10" data-testid="about-page">
      <div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#FBBF24] font-bold mb-3">
          <Sparkles size={12} /> About Zenith Flow Dynamics
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight max-w-4xl">
          A modern Commerce-as-a-Service platform for the next generation of{" "}
          <span className="text-[#FBBF24]">digital entrepreneurs.</span>
        </h1>
        <p className="text-white/70 max-w-3xl mt-6 text-base md:text-lg leading-relaxed">
          Zenith Flow Dynamics empowers ordinary people to build sustainable online businesses
          by selling real products through modern technology, transparent partner rewards,
          and a nationwide fulfillment network. We handle the sourcing, warehousing, shipping,
          and customer support — you focus on growing your business.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-3">
        {[
          { icon: Globe, title: "Our Mission", body: "Democratize online entrepreneurship. Any Filipino with a phone and an internet connection should be able to start a real online business — without inventory, warehouses, or years of experience." },
          { icon: Package, title: "Our Products", body: "A curated catalog of real physical goods across health, beauty, electronics, fashion, food, and lifestyle. Sourced from trusted manufacturers, priced for retail margin, delivered nationwide." },
          { icon: Bot, title: "Our Technology", body: "AI-powered marketing tools, personal online stores, real-time order tracking, and a transparent commission engine. Everything a modern commerce partner needs — in one platform." },
        ].map((c) => (
          <div key={c.title} className="glass-card p-6" data-testid={`about-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <c.icon size={22} className="text-[#FBBF24]" />
            <div className="mt-3 font-display font-black text-lg">{c.title}</div>
            <p className="mt-2 text-sm text-white/65 leading-relaxed">{c.body}</p>
          </div>
        ))}
      </div>

      <div className="glass-card gold-border p-8">
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#FBBF24] font-bold mb-2">Our Philosophy</div>
        <h2 className="font-display text-2xl md:text-3xl font-black tracking-tight">
          We are not an investment platform. We are a{" "}
          <span className="text-[#FBBF24]">business platform.</span>
        </h2>
        <p className="text-white/70 mt-4 max-w-3xl leading-relaxed">
          Every peso earned on Zenith Flow Dynamics is funded by real product sales to real customers.
          There is no daily yield, no ROI, no capital deployment, no passive income promises.
          Just real commerce — with the tools, training, and fulfillment to help you build something lasting.
        </p>
      </div>

      <div className="text-center pt-6">
        <Link to="/register" className="btn-deploy inline-flex items-center gap-2 px-8 py-3 rounded-md text-sm font-bold uppercase tracking-widest" data-testid="about-cta">
          <ArrowUpRightSquare size={16} /> Become a Partner
        </Link>
      </div>
    </div>
  );
}
